<ion-card style="margin-top: 10%;" *ngIf="!businessService.business_request.id">
  <ion-row>
    <ion-col size="12" sizeMd="6" class="padding5">
      <app-a-input [label]="trans.translate('Your name')+ '*'"
        [(variable)]="businessService.business_request.name"></app-a-input>
    </ion-col>
    <ion-col size="12">
      <app-a-input [label]="trans.translate('Mobile number') + '*'" [type]="'number'"
        [(variable)]="businessService.business_request.mobile"></app-a-input>
    </ion-col>
    <ion-col size="12">
      <app-a-input [label]="trans.translate('Community Name') + ' *'"
        [(variable)]="businessService.business_request.community_name"></app-a-input>
    </ion-col>
    <ion-col size="12">
      <ion-badge color="success" class="padding5 margin5px" mode="ios" (click)="addSubCommunity()">{{'Add sub community'|translate}}
      </ion-badge>
      <div *ngIf="businessService.business_request.sub_community">
        <ion-badge color="medium" class="padding5 margin5px" mode="ios"
          *ngFor="let item of businessService.business_request.sub_community">
          <span (click)="addSubCommunity(item)">{{item}}</span>
          <ion-icon name="close-circle" color="danger" (click)="removeSubCommunity(item)"></ion-icon>
        </ion-badge>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="6">
      <ion-button (click)="cancelBusiness()" expand="block" fill="outline">
        Cancel
      </ion-button>
    </ion-col>
    <ion-col size="6">
      <ion-button (click)="saveBusiness()" expand="block">
        Save Business
      </ion-button>
    </ion-col>
  </ion-row>
</ion-card>
<ion-card style="position: relative; top: 25%;" *ngIf="businessService.business_request.id!=null">
  <div class="padding5">
    <p>{{'Dear'|translate}}<span> {{ businessService.business_request.name}}</span></p><br>
    <b>{{'Note:'|translate }}</b> {{'Your request for new community has been sent to admin. Admin will verify and create the community.You will be notified once the community is created.'|translate}}
  </div>
</ion-card>